import { PluginObject } from 'vue'

import KY, { Options } from 'ky'
import { EXAPI } from './types'
import { defaultApi } from './default'

// eslint-disable-next-line
const _deepAssign = (target: any, assign: any) => {
  Object.keys(assign).forEach(key => {
    if (typeof assign[key] != 'object' || assign[key] === null) {
      target[key] = assign[key]
    } else if (Array.isArray(assign[key])) {
      target[key] = [].slice.apply(assign[key])
    } else {
      if (typeof target[key] != 'object' || target[key] === null) {
        target[key] = {}
      }
      _deepAssign(target[key], assign[key])
    }
  })
  return target
}

// eslint-disable-next-line
const deepAssign = (target: any, ...args: any[]) => {
  args.forEach(v => {
    _deepAssign(target, v)
  })
  return target
}

const _exapi = (): EXAPI => {
  const timeout = false
  const headers = {
    'content-type': 'application/json'
    // eslint-disable-next-line
  } as any

  const ky = (url: string, options?: Options) =>
    KY(url, deepAssign({}, { headers, timeout }, options || {}))

  return {
    ky,
    default: defaultApi(ky)
  }
}

const Plugin: PluginObject<undefined> = {
  install: Vue => {
    const exapi = _exapi()

    Vue.$exapi = exapi
    Object.defineProperty(Vue.prototype, '$exapi', {
      get() {
        return exapi
      }
    })
  }
}

export default Plugin
